"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconIndex_enum_1 = require("./IconIndex.enum");
var Icons_1 = require("../Icons");
var IconIndex_enum_2 = require("./IconIndex.enum");
exports.IconIndex = IconIndex_enum_2.IconIndex;
var Icon = function (_a) {
    var name = _a.name, className = _a.className, dusk = _a.dusk;
    switch (name) {
        case IconIndex_enum_1.IconIndex.DASHBOARD:
            return react_1.default.createElement(Icons_1.DashboardIcon, { className: className, dusk: dusk });
        case IconIndex_enum_1.IconIndex.DOWNLOAD:
            return react_1.default.createElement(Icons_1.DownloadIcon, { className: className, dusk: dusk });
        case IconIndex_enum_1.IconIndex.UPLOAD:
            return react_1.default.createElement(Icons_1.UploadIcon, { className: className, dusk: dusk });
        case IconIndex_enum_1.IconIndex.DELETE:
            return react_1.default.createElement(Icons_1.DeleteIcon, { className: className, dusk: dusk });
        case IconIndex_enum_1.IconIndex.TIMES:
            return react_1.default.createElement(Icons_1.DeleteIcon, { className: className, dusk: dusk });
        case IconIndex_enum_1.IconIndex.SUCCESS:
            return react_1.default.createElement(Icons_1.SuccessIcon, { className: className, dusk: dusk });
        case IconIndex_enum_1.IconIndex.ACTIVITY:
            return react_1.default.createElement(Icons_1.ActivityIcon, { className: className, dusk: dusk });
        default:
            return null;
    }
};
exports.default = Icon;
//# sourceMappingURL=index.js.map